// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__35vsp","title":"Images90_title__2Ofr2","images":"Images90_images__3ZRYQ"};